import {Fancybox} from "@fancyapps/ui";
import JsTabs from "js-tabs";
import Swiper, {Navigation, Thumbs, Pagination} from 'swiper';
import {Tooltip} from "bootstrap";
import Comment from "./Components/Comments/comment";

Swiper.use([Navigation, Thumbs, Pagination]);

import events from "./base";

new Comment(events);

require('./base');

import Agent from "./Components/Core/agent";
import {notice} from "./Components/UI/notice";
import {initAddCommentForm} from "./Components/Comments/comment";

import {GET2URL} from "./Components/Url";
import {parseHTML} from "./Components/Core/common";

import StarRating from 'star-rating.js';

document.querySelectorAll('.js_info').forEach(item => {
    item.querySelector('.btn-close').addEventListener('click', function(){
        item.style.display = 'none';
    });
});

document.querySelectorAll('.star-rating').forEach(item => {
    new StarRating(item, {
        clearable: true,
        tooltip: false,
        maxStars: 5,
    });
});

const loadCommentForm = document.querySelector('.js_load_comment_form');
if (loadCommentForm) {
    let observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let js_comment_form = document.querySelector('.js_comment_form');

                if (!js_comment_form) {
                    obs.unobserve(entry.target);
                }

                if (!js_comment_form.querySelector('form')) {
                    let id = loadCommentForm.getAttribute('data-page');
                    let type = loadCommentForm.getAttribute('data-type');
                    Agent.post(`/api/comment/form/${id}/${type}/`).then(e => e.json()).then(e => {
                        if (e.success) {
                            js_comment_form.innerHTML = e.data;
                            js_comment_form.querySelectorAll('.star-rating').forEach(item => {
                                new StarRating(item, {
                                    clearable: true,
                                    tooltip: false,
                                    maxStars: 5,
                                });
                            });
                            initAddCommentForm(js_comment_form.querySelector('form'));
                        } else {
                            notice(e.message);
                        }
                    }).catch(e => console.log(e)).finally(() => {
                        obs.unobserve(entry.target);
                    });
                }

            }
        });
    });

    observer.observe(loadCommentForm);
}

const _scrollTo = (block, yOffset) => {
    const y = block.getBoundingClientRect().top + window.pageYOffset + (yOffset || 0);
    window.scrollTo({top: y, behavior: 'smooth'});
};

document.querySelectorAll('a[href*="#"]').forEach(item => item.addEventListener('click', e => {
    e.preventDefault();
    const block = document.querySelector(item.getAttribute('href'));
    if (block) {
        _scrollTo(block, -document.querySelector('header').scrollHeight);
        block.click();
    }
}));


document.querySelectorAll('.js_load_more').forEach(item => item.addEventListener('click', () => {

    let url = item.dataset.api + GET2URL({}, []);
    item.classList.add('preloader');

    Agent.post(url, '')
        .then(e => e.json())
        .then(e => {
            if (e.success) {
                if (e.next) {
                    item.dataset.api = e.next;
                } else {
                    item.classList.add('d-none');
                }
                if (e.data.length) {
                    item.closest('.js_load_more_container').querySelector('.js_load_more_container_block').append(parseHTML(e.data));
                    events.dispatch('filter.search');
                }
            }
        })
        .catch(e => console.log(e))
        .finally(() => {
            item.classList.remove('preloader');
        });
}));

function tabs(tabName) {
    if (document.querySelector(tabName)) {
        document.querySelectorAll(tabName).forEach(item => {
            let tab = new JsTabs({
                elm: item,
                shouldScrollTabIntoView: false,
            });
            tab.init();
            item.querySelector(".js-tabs__tab").classList.add("active");
            item.querySelector(".js-tabs__content").classList.add("active");
        });
    }
}

tabs('.gallery-tabs');
tabs('.product-tabs');
tabs('.collection-tabs');
tabs('.order-tabs');
tabs('.city-tabs');

if (document.querySelector('.map')) {
    let load = false;
    window.addEventListener('scroll', function () {
        if (load === false) {
            load = true;
            setTimeout(() => {
                let script = document.createElement('script');
                script.async = true;
                script.src = 'https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3A7c33859c59c32d397ac379029013b7830071edfaa86f8baa714239f10a2bceac&amp;width=100%25&amp;height=100%&amp;lang=ru_RU&amp;scroll=false';
                document.querySelector('.map-item').replaceWith(script);
            }, 1000);
        }
    });
}

document.querySelectorAll('.js_disabled-input').forEach(item => {
    let btn = item.querySelector('.js_disabled-inputBtn');
    let block = item.querySelector('.js_disabled-inputBlock');
    let changeBtn = item.querySelector('.js_disabled-inputChange');
    btn.addEventListener('click', () => {
        btn.classList.toggle('active');
        if (btn.classList.contains('active')) {
            block.querySelectorAll('.main-input').forEach(input => {
                input.disabled = false;
            });
            changeBtn.disabled = false;
        } else {
            block.querySelectorAll('.main-input').forEach(input => {
                input.disabled = true;
            });
            changeBtn.disabled = true;
        }
    });
});

if (document.querySelector('.category-filter')) {
    let btn = document.querySelector('.btn-filter');
    let filter = document.querySelector('.category-filter');
    document.addEventListener('click', (e) => {
        if (filter.classList.contains('active')) {
            if (e.target === filter) {
                filter.classList.remove('active');
            }
        }
    });
    btn.addEventListener('click', () => {
        filter.classList.add('active');
    });
}

if (document.querySelector('.scroll-top')) {
    document.addEventListener('scroll', () => {
        if (window.pageYOffset > 300) {
            document.querySelector('.scroll-top').classList.add('active');
        } else {
            document.querySelector('.scroll-top').classList.remove('active');
        }
    });
    document.querySelector('.scroll-top').addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}

let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
});
window.noty = notice;

if (document.querySelector(".chosen-item")) {
    document.querySelectorAll('.chosen-item').forEach(item => {
        item.querySelector('.btn-close').addEventListener('click', () => {
            item.closest("[class^='col']").remove();
        });
    });
}

function dropdawn(item){                       
    item.addEventListener("mouseover", function(){                        
        item.querySelector('.dropdawn-btn').classList.add('active');
        item.querySelector('.dropdawn-menu').classList.add('active');                  
    });
    item.addEventListener("mouseleave", function(){
        let timer = setTimeout(function(){
            item.querySelector('.dropdawn-menu').classList.remove('active');
            item.querySelector('.dropdawn-btn').classList.remove('active');
        }, 100);
        item.addEventListener('mouseover', function(){
            item.querySelector('.dropdawn-btn').classList.add('active');
            item.querySelector('.dropdawn-menu').classList.add('active');
            clearTimeout(timer);              
        });                        
    });                         
}
function dropdawnM(item){
    let btn = item.querySelector('.dropdawn-btn');
    let menu = item.querySelector('.dropdawn-menu');
    btn.addEventListener('click', () => {            
        menu.classList.toggle('active');
        btn.classList.toggle('active');           
    });      
    document.addEventListener('click', (e) => {                                
        if(!e.target.closest('.dropdawn-menu') && !e.target.closest('.dropdawn-btn')){                          
            btn.classList.remove('active');
            menu.classList.remove('active');
        }            
    });
} 
document.querySelectorAll('.dropdawn').forEach(item => {
    if(window.outerWidth >= 768){
        dropdawn(item);    
    } else {
        dropdawnM(item);    
    } 
    window.addEventListener('resize', function(){
        if(window.outerWidth >= 768){
            dropdawn(item);    
        } else {
            dropdawnM(item);    
        }    
    });    
});

document.querySelectorAll('.slider-tabs').forEach(item => {

    let btns = item.querySelector('.custom-tabs');
    let container = item.querySelectorAll('.custom-container');

    if (btns) {
        btns.querySelector('.custom-tab').classList.add('active');

        container.forEach(item => {
            item.querySelector('.custom-item').classList.add('active');
        });

        btns.querySelectorAll('.custom-tab').forEach(btn => {
            btn.addEventListener('click', () => {
                btns.querySelectorAll('.custom-tab').forEach(btn => {
                    btn.classList.remove('active');
                });
                btn.classList.add('active');
                let data = btn.dataset.tab;
                item.querySelectorAll('.custom-item').forEach(item => {
                    item.classList.remove('active');
                });
                item.querySelectorAll(`.custom-item[data-tab="${data}"]`).forEach(item => {
                    item.classList.add('active');
                });
            });

        });
    }
});

if (document.querySelector('.category-show')) {
    let block = document.querySelector('.category-show');
    let btns = document.querySelectorAll('.btn-show');

    btns.forEach(item => {
        item.addEventListener('click', () => {
            let items = block.querySelectorAll('.product-item');
            btns.forEach(item => item.classList.remove('active'));
            item.classList.add('active');
            if (item.classList.contains('inline-show')) {
                block.classList.remove('grid-block');
                block.classList.add('inline-block');
                items.forEach(item => item.classList.add('inline-block'));
            } else {
                block.classList.add('grid-block');
                block.classList.remove('inline-block');
                items.forEach(item => item.classList.remove('inline-block'));
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.slider-baner')) {
        new Swiper('.slider-baner', {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.slider-baner-next',
                prevEl: '.slider-baner-prev',
            },
            pagination: {
                el: '.slider-baner-pagination',
                type: 'bullets'
            }
        });
    }
    if(document.querySelector('.slider-baner-brands')){
        new Swiper('.slider-baner-brands', {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 10,
            navigation: {
                nextEl: '.slider-baner-brands-next',
                prevEl: '.slider-baner-brands-prev',
            },            
        });
    }
    if (document.querySelector('.slider-4')) {
        document.querySelectorAll('.slider-4').forEach(item => {
            let currentCategory = item.dataset.category;
            let currentNavigation = document.querySelector(`.slider-navigation-4[data-category="${currentCategory}"]`);
            let navigation = {};
            let pagination = {};
            if (currentNavigation) {
                let next = currentNavigation.querySelector('.slider-next');
                let prev = currentNavigation.querySelector('.slider-prev');
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets'
                },
                    navigation = {
                        nextEl: next,
                        prevEl: prev,
                    };
            }
            new Swiper(item, {
                modules: [Navigation, Pagination],
                spaceBetween: 10,
                slidesPerView: 1,
                navigation: navigation,
                pagination: pagination,
                watchSlidesVisibility: true,
                slideActiveClass: "active",
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    },
                    1600: {
                        spaceBetween: 40,
                        slidesPerView: 4,
                    },
                }
            });
        });
    }
    if (document.querySelector('.slider-3')) {
        document.querySelectorAll('.slider-3').forEach(item => {
            let currentCategory = item.dataset.category;
            let currentNavigation = document.querySelector(`.slider-navigation-3[data-category="${currentCategory}"]`);
            let navigation = {};
            let pagination = {};
            if (currentNavigation) {
                let next = currentNavigation.querySelector('.slider-next');
                let prev = currentNavigation.querySelector('.slider-prev');
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets'
                };
                navigation = {
                    nextEl: next,
                    prevEl: prev,
                };
            }
            new Swiper(item, {
                modules: [Navigation, Pagination],
                spaceBetween: 10,
                slidesPerView: 1,
                navigation: navigation,
                pagination: pagination,
                watchSlidesVisibility: true,
                slideActiveClass: "active",
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    },
                    1524: {
                        spaceBetween: 40,
                        slidesPerView: 3,
                    },
                }
            });
        });
    }
    if (document.querySelector('.slider-2')) {
        document.querySelectorAll('.slider-2').forEach(item => {
            let currentCategory = item.dataset.category;
            let currentNavigation = document.querySelector(`.slider-navigation-2[data-category="${currentCategory}"]`);
            let navigation = {};
            let pagination = {};
            if (currentNavigation) {
                let next = currentNavigation.querySelector('.slider-next');
                let prev = currentNavigation.querySelector('.slider-prev');
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets'
                };
                navigation = {
                    nextEl: next,
                    prevEl: prev,
                };
            }
            new Swiper(item, {
                modules: [Navigation, Pagination],
                spaceBetween: 10,
                slidesPerView: 1,
                navigation: navigation,
                pagination: pagination,
                watchSlidesVisibility: true,
                slideActiveClass: "active",
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1524: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    }
                }
            });
        });
    }
    if (document.querySelector(".product-slide")) {
        let swiperProductThumbs = new Swiper('.product-slide-thumbs', {
            spaceBetween: 10,
            slidesPerView: 2,
            watchSlidesVisibility: true,
            slideActiveClass: "active",
            breakpoints: {
                576: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 4,
                },
                992: {
                    slidesPerView: 3,
                },
                1600: {
                    slidesPerView: 4
                }
            }
        });
        new Swiper('.product-slide', {
            modules: [Navigation, Thumbs],
            spaceBetween: 10,
            slidesPerView: 1,
            thumbs: {
                swiper: swiperProductThumbs
            },
            navigation: {
                nextEl: ".product-slide-next",
                prevEl: ".product-slide-prev",
            },
        });
    }
    if (document.querySelector('.slider-compare')) {
        document.querySelectorAll('.slider-compare').forEach(item => {
            let currentCategory = item.dataset.category;
            let currentNavigation = document.querySelector(`.slider-compare-navigation[data-category="${currentCategory}"]`);
            let navigation = {};
            let pagination = {};
            if (currentNavigation) {
                let next = currentNavigation.querySelector('.slider-next');
                let prev = currentNavigation.querySelector('.slider-prev');
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets'
                };
                navigation = {
                    nextEl: next,
                    prevEl: prev,
                };
            }
            let mainCompare;
            let compareThumbs = [];
            document.querySelectorAll(`.slider-compare-thumbs[data-category="${currentCategory}`).forEach(function (thumb, index) {
                compareThumbs[index] = new Swiper(thumb, {
                    modules: [Navigation],
                    spaceBetween: 10,
                    slidesPerView: 1,
                    navigation: navigation,
                    pagination: pagination,
                    watchSlidesVisibility: true,
                    slideActiveClass: "active",
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 40
                        },
                        1600: {
                            spaceBetween: 40,
                            slidesPerView: 4,
                        },
                    }
                });
            });
            mainCompare = new Swiper(item, {
                modules: [Navigation],
                spaceBetween: 10,
                slidesPerView: 1,
                navigation: navigation,
                pagination: pagination,
                watchSlidesVisibility: true,
                slideActiveClass: "active",
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    },
                    1600: {
                        spaceBetween: 40,
                        slidesPerView: 4,
                    },
                }
            });
            mainCompare.on('slideChange', function () {
                console.log(mainCompare.translate);
                compareThumbs.forEach(item => {
                    item.translateTo(mainCompare.translate, 300, false, false);
                });
            });
            compareThumbs.forEach(thumb => {
                thumb.on('slideChange', function () {
                    console.log(thumb.translate);
                    compareThumbs.forEach(item => {
                        item.translateTo(thumb.translate, 300, false, false);
                    });
                    mainCompare.translateTo(thumb.translate, 300, false, false);
                });
            });
        });
    }
});

let filterListInputTimer;
document.querySelectorAll('.filterListInput').forEach(function (item) {
    item.addEventListener('input', function () {
        clearTimeout(filterListInputTimer);
        filterListInputTimer = setTimeout(function () {
            let filter = item.value.toUpperCase();
            let block = item.closest('.rbm_js_filter2_string_block');
            block.querySelectorAll('.js_input_name').forEach(function (l) {
                let is = l.innerHTML.toUpperCase().indexOf(filter) > -1;

                if (is) {
                    l.closest('label').classList.remove('d-none');
                } else {
                    l.closest('label').classList.add('d-none');
                }
            });
        }, 300);
    });
});

window.print_page = pageId => {
    let btn = document.querySelector('#print_page_button');
    btn.classList.add('preloader');
    let currentFrame = document.querySelector('#print_page_id');
    if (currentFrame) {
        currentFrame.parentNode.removeChild(currentFrame);
    }

    let ifrm = document.createElement("iframe");
    ifrm.setAttribute('id', `print_page_id`);
    ifrm.setAttribute('style', `display:none;`);
    ifrm.setAttribute('name', `print_page_id`);
    ifrm.setAttribute("src", `/print/${pageId}.html`);
    ifrm.style.width = "0px";
    ifrm.style.height = "0px";
    document.body.appendChild(ifrm);

    ifrm.onload = function () {
        btn.classList.remove('preloader');
        ifrm.focus();
        ifrm.contentWindow.print();
    };
};